import { useState } from "react";
import { Button, Table } from "flowbite-react";
import { FaRegTrashAlt } from "react-icons/fa";
import { HiPencil } from "react-icons/hi";
import DeleteModal from "./DeleteModal";

const ProfileRow = ({ profile, fetchProfiles, onEdit }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <Table.Row className="bg-white">
      <Table.Cell>{profile.name} {profile.lastName}</Table.Cell>
      <Table.Cell className="flex gap-2 items-center">
        <Button onClick={() => onEdit(profile)}>
          <HiPencil />
        </Button>
        <Button
          onClick={() => setOpenModal(true)}
          color="failure"
        >
          <FaRegTrashAlt />
        </Button>
        <DeleteModal
          profile={profile}
          fetchProfiles={fetchProfiles}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      </Table.Cell>
    </Table.Row>
  )
}

export default ProfileRow;
